import RateClient from '@/network/rates';
import type { Currency } from '@/types';

export default {
    crypto(currency: Currency = 'USD' as Currency) {
        return RateClient.crypto(currency);
    },
};
